import React, { Component } from 'react'
import { I18n } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router'

import { i18nKeys } from '../../../app.i18n'
import { ConfirmDialog, FormPrompt } from '../../../shared'

type Props = {
  active: boolean
  children: string
} & RouteComponentProps<{}>

export class DefaultFormPrompt extends Component<Props> {
  render() {
    const { active, history, children } = this.props

    return (
      <I18n>
        {(t) => (
          <FormPrompt active={active} history={history}>
            {({ showPrompt, originalPathname, onClose, onConfirm }) => (
              <ConfirmDialog
                isOpen={showPrompt}
                onClose={onClose}
                onConfirm={this.handleConfirm(originalPathname, onConfirm)}
                titleText={t(i18nKeys.frontFace.shared.discardDialog.title)}
                bodyText={children}
                translate={t}
              />
            )}
          </FormPrompt>
        )}
      </I18n>
    )
  }

  private handleConfirm = (pathname: string, onConfirm: () => void) => () => {
    onConfirm()
    this.props.history.push({ pathname })
  }
}

const EnhancedDefaultFormPrompt = withRouter(DefaultFormPrompt)

export default EnhancedDefaultFormPrompt



// WEBPACK FOOTER //
// ./src/app/front-face/shared/default-form-prompt/default-form-prompt.tsx